
































































import { Component } from 'vue-property-decorator';
import RowsTable from '@/components/Table/RowsTable.vue';
import TextInput from '@/components/TextInput/TextInput.vue';
import FlexButton from '@/components/FlexButton/FlexButton.vue';
import CustomSelect from '@/components/CustomSelect/CustomSelect.vue';
import AdminService from '@/api/AdminService';
import { HeaderList } from '@/components/Table/TableModel';
import {
  CustomSelectModel,
  CustomSelectGroup,
  CustomSelectOption
} from '@/components/CustomSelect/CustomSelectModel';
import DateUtils from '@/utils/DateUtils';
import BasePagination from '@/components/BasePagination/BasePagination.vue';
import ContentContainer from '@/components/molecules/ContentContainer/ContentContainer.vue';

import Table from '@/components/molecules/Table/Table.vue';
import TableFilters from '@/components/molecules/TableFilters/TableFilters.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import UserIcon from '@/components/molecules/UserIcon/UserIcon.vue';
import { getBusinessLocationInfo } from '@/utils/businessLocationHelper';

@Component({
  components: {
    Table,
    FlexButton,
    RowsTable,
    CustomSelect,
    TextInput,
    ContentContainer,
    TableFilters,
    TableCell,
    TableHeader,
    TableRow,
    UserIcon
  }
})
export default class TransactionsList extends BasePagination {
  service = new AdminService();
  time: { extras?: string } = {};

  getCardType(cardType: string) {
    switch (cardType) {
      case 'master':
        return 'mastercard';

      default:
        return cardType;
    }
  }

  initHeader() {
    return [
      new HeaderList(`Card type`, 'none'),
      new HeaderList(`Card last 4 digits`, 'none'),
      new HeaderList(`Amount`, 'none', '12px'),
      new HeaderList(`Business name`, 'none', '12px'),
      new HeaderList(`Business location`, 'none', '12px'),
      new HeaderList(`Customer name`, 'none'),
      new HeaderList(`Status`, 'none', '12px'),
      new HeaderList(`Date and time`, 'none')
    ];
  }

  addRowsList(data: any[]): any[] {
    let rows: any[] = [];

    data.forEach((row: any) => {
      const business = row.fidelTransaction
        ? row.fidelTransaction.business
        : row.wallet.business;
      const customer = row.fidelTransaction
        ? row.fidelTransaction.customer
        : row.wallet.owner;
      rows.push({
        cardType: row.creditCard ? row.creditCard.cardType : '',
        cardNumber:
          row.creditCard && row.creditCard.number
            ? row.creditCard.number
            : 'Not informed',
        amount: `$${row.money}`,
        businessName: business.name,
        businessLocation: getBusinessLocationInfo(business),

        customerName: `${customer.name} ${customer.lastname}`,
        status: this.treatStatus(row.status),
        date: DateUtils.formatISODate(row.createdAt, true)
      });
    });

    return rows;
  }

  treatStatus(status: string) {
    return `${status[0].toUpperCase()}${status.slice(1)}`;
  }

  treatCardNumber(cardNumber: string) {
    return cardNumber
      .split('-')
      .splice(2, 2)
      .join(' ')
      .replace(/X/g, '•');
  }

  periodChanged(data: any) {
    if (data[0].uuid == 'allTime') {
      delete this.time.extras;
    } else {
      this.time = {
        extras: `time:${data[0].uuid}`
      };
    }

    this.reloadList(true);
  }

  async reloadList(
    clearList?: boolean,
    refreshCurrent?: boolean,
    query?: string
  ) {
    if (clearList) {
      this.resetPagination();
      this.dataList.list = [];
      this.maxItems = false;
    }

    if (this.refreshing || this.maxItems) return;
    this.$showLoaderWithLocker();
    this.refreshing = true;

    try {
      const response = await this.service.getTransactions(
        this.sortField,
        this.sortOrder,
        this.pagination,
        this.query,
        this.time
      );
      const { data } = response;
      const { items, links } = data;
      if (refreshCurrent) {
        // refresh page and reinitilize pagination
        this.resetPagination();
        this.pagination = links.next;
        if (!links.next) this.maxItems = true;
        this.dataList.list = this.addRowsList(items);
      } else {
        // refresh page and add items
        if (!links.next) this.maxItems = true;
        this.pagination = links.next;
        this.dataList.list = this.dataList.list.concat(this.addRowsList(items));
      }

      this.$hideLoader();
      this.isLoading = true;
      this.refreshing = false;
    } catch (e) {
      console.error(e);
      this.$hideLoader();
    }
  }

  initFilterModel() {
    const actionGroup = new CustomSelectGroup([
      new CustomSelectOption('allTime', 'All time', true),
      new CustomSelectOption('sevenDays', '7 days'),
      new CustomSelectOption('oneMonth', '1 month'),
      new CustomSelectOption('threeMonths', '3 month')
    ]);

    this.filterModel = new CustomSelectModel(
      [actionGroup],
      `By period`,
      false,
      false,
      false,
      true
    );
  }
}
